import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useStockStatisticModel } from "../stockStatisticModel";
import { IStockStatisticDetail } from "../stockStatisticService"
import useNavModel from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys } = useStockStatisticModel();
    const { selectedNavId, replaceNav } = useNavModel();

    const onLook = (text: string) => {
        console.log(text)
        replaceNav(selectedNavId, "4-1-3", { id: text as string, mode: "look" }, true);
    }
    const columns: ColumnsType<IStockStatisticDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            fixed: 'left',
            render: (t, r, i) => `${i + 1}`
        }, {
            // title: '商品编号',
            title: Locale["Material Code"],
            width: 180,
            fixed: 'left',
            dataIndex: 'materialCode',
            ellipsis:true,
            render: text => <span onClick={() => onLook(text)} className="click-span">{text}</span>
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            width: 160,
            fixed: 'left',
            dataIndex: 'materialName',
            render: (text:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '商品名称-英文',
            title: Locale['Material Name En'],
            width: 160,
            dataIndex: 'nameEn',     
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,             
        }, {
            // title: '所属库房',
            title: Locale["Warehouse Managements"],
            width: 160,
            dataIndex: 'warehouseName',
        }, {
            // title: '所属货位',
            title: Locale["Shelf"],
            width: 160,
            dataIndex: 'shelfCode',
        }, {
            // title: '商品分类',
            title: Locale["Material Type"],
            width: 160,
            dataIndex: 'typeName',
        }, {
            // title: '商品品牌',
            title: Locale["Material Brand"],
            width: 160,
            dataIndex: 'brandName',
        }, {
            // title: '规格型号',
            title: Locale["Spec&Model"],
            width: 120,
            dataIndex: 'model',
            render: (text:any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '库存数量',
            title: Locale["Qty in Stock"],
            width: 160,
            dataIndex: 'inventoryNum',
        }, {
            // title: '进货价',
            title: Locale["Purchase Price"],
            width: 160,
            dataIndex: 'purchasePrice',
        }, {
            // title: '零售价',
            title: Locale["Retail Price"],
            width: 160,
            dataIndex: 'retailPrice',
        }, {
            // title: '进货价（最近）',
            title: Locale["Latest Purchase Price"],
            width: 160,
            dataIndex: 'latestPurPrice',
        }, {
            // title: '进货价（平均）',
            title: Locale["Average Purchase Price"],
            width: 160,
            dataIndex: 'averagePurchasePrice',
        }, {
            // title: '零售价（最近）',
            title: Locale["Latest Retail Price"],
            width: 160,
            dataIndex: 'lateSalePrice',
        }, {
            // title: '库存成本（平均）',
            title: Locale["Average Inventory Cost"],
            width: 160,
            dataIndex: 'averageAmount',
        }, {
            // title: '库存成本（最近）',
            title: Locale["Latest Inventory Cost"],
            width: 160,
            dataIndex: 'latestAmount',
        }, {
            // title: '库存上限',
            title: Locale["Upper Limit"],
            width: 160,
            dataIndex: 'limitUpper',
        }, {
            // title: '库存下限',
            title: Locale["Lower Limit"],
            width: 160,
            dataIndex: 'limitLower',
        }
    ];
    useEffect(() => {
        loadData().then();
    }, [])
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IStockStatisticDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.id) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.id as string]);
                        }
                    },
                };
            }}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
